import { render, staticRenderFns } from "./notokenauth.vue?vue&type=template&id=d91ea1b0&"
import script from "./notokenauth.vue?vue&type=script&lang=js&"
export * from "./notokenauth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports